import React from "react";
import {
  makeStyles,
  Theme,
  createStyles,
  Container,
  Grid,
} from "@material-ui/core";

const useStyles = makeStyles((theme: Theme) => createStyles({}));

interface WebToonImgListProps {
  url: string;
}

function WebToonImgList({ url }: WebToonImgListProps) {

  const classes = useStyles();
  return (
    <div>
      <Grid xs={12} item component={"div"}>
        <img src={`${url}`} style={{ width: "100%" }}></img>
      </Grid>
    </div>
  );
}

export default WebToonImgList;
